<ac-icon class="icon alert-icon" name="alert" size="small" />
<ac-icon class="icon complete-icon" name="complete" size="small" />
<ng-content />
<ng-content select="[action]" />
